"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Device Service API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.245
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShadowApi = exports.ShadowApiFactory = exports.ShadowApiFp = exports.ShadowApiAxiosParamCreator = exports.MessagingApi = exports.MessagingApiFactory = exports.MessagingApiFp = exports.MessagingApiAxiosParamCreator = exports.DeviceStatusApi = exports.DeviceStatusApiFactory = exports.DeviceStatusApiFp = exports.DeviceStatusApiAxiosParamCreator = exports.DeviceStatsApi = exports.DeviceStatsApiFactory = exports.DeviceStatsApiFp = exports.DeviceStatsApiAxiosParamCreator = exports.DeviceRegistryApi = exports.DeviceRegistryApiFactory = exports.DeviceRegistryApiFp = exports.DeviceRegistryApiAxiosParamCreator = exports.DeviceMonitoringApi = exports.DeviceMonitoringApiFactory = exports.DeviceMonitoringApiFp = exports.DeviceMonitoringApiAxiosParamCreator = exports.DeviceHeartbeatApi = exports.DeviceHeartbeatApiFactory = exports.DeviceHeartbeatApiFp = exports.DeviceHeartbeatApiAxiosParamCreator = exports.DeviceControlApi = exports.DeviceControlApiFactory = exports.DeviceControlApiFp = exports.DeviceControlApiAxiosParamCreator = exports.DeviceUpdateEventTypeEnum = exports.DeviceProvisioningOriginEnum = exports.DeviceLedColorEnum = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
exports.DeviceLedColorEnum = {
    RED: 'RED',
    GREEN: 'GREEN',
    BLUE: 'BLUE',
    WHITE: 'WHITE'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.DeviceProvisioningOriginEnum = {
    COW_FARM_CHANGE: 'COW_FARM_CHANGE',
    PRE_PROVISION: 'PRE_PROVISION',
    DEPROVISION: 'DEPROVISION'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.DeviceUpdateEventTypeEnum = {
    CREATED: 'Created',
    UPDATED: 'Updated'
};
/**
 * DeviceControlApi - axios parameter creator
 * @export
 */
var DeviceControlApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Endpoint that will set collar data collection mode
         * @param {string} serialNumber Serial Number
         * @param {IDeviceDataCollectionRequest} [iDeviceDataCollectionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestDeviceDataCollection: function (serialNumber, iDeviceDataCollectionRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    (0, common_1.assertParamExists)('requestDeviceDataCollection', 'serialNumber', serialNumber);
                    localVarPath = "/devices/{serialNumber}/data-capture"
                        .replace("{".concat("serialNumber", "}"), encodeURIComponent(String(serialNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iDeviceDataCollectionRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Endpoint that will request the collar enter power off mode
         * @param {string} serialNumber Serial Number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestDeviceEnterPowerOffMode: function (serialNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    (0, common_1.assertParamExists)('requestDeviceEnterPowerOffMode', 'serialNumber', serialNumber);
                    localVarPath = "/devices/{serialNumber}/enter-power-off-mode"
                        .replace("{".concat("serialNumber", "}"), encodeURIComponent(String(serialNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Endpoint that will request the collar perform a reset
         * @param {string} serialNumber Serial Number
         * @param {IDeviceResetRequest} [iDeviceResetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestDeviceReset: function (serialNumber, iDeviceResetRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    (0, common_1.assertParamExists)('requestDeviceReset', 'serialNumber', serialNumber);
                    localVarPath = "/devices/{serialNumber}/reset"
                        .replace("{".concat("serialNumber", "}"), encodeURIComponent(String(serialNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iDeviceResetRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Endpoint that will request the collar perform a settings clear/resynch
         * @param {string} serialNumber Serial Number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestDeviceSettingsClear: function (serialNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    (0, common_1.assertParamExists)('requestDeviceSettingsClear', 'serialNumber', serialNumber);
                    localVarPath = "/devices/{serialNumber}/clear-settings"
                        .replace("{".concat("serialNumber", "}"), encodeURIComponent(String(serialNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Endpoint that will request the collar perform an Wifi check in
         * @param {string} serialNumber Serial Number
         * @param {IDeviceWifiCheckInRequest} [iDeviceWifiCheckInRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestDeviceWifiCheckIn: function (serialNumber, iDeviceWifiCheckInRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    (0, common_1.assertParamExists)('requestDeviceWifiCheckIn', 'serialNumber', serialNumber);
                    localVarPath = "/devices/{serialNumber}/wifi-checkin"
                        .replace("{".concat("serialNumber", "}"), encodeURIComponent(String(serialNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iDeviceWifiCheckInRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.DeviceControlApiAxiosParamCreator = DeviceControlApiAxiosParamCreator;
/**
 * DeviceControlApi - functional programming interface
 * @export
 */
var DeviceControlApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DeviceControlApiAxiosParamCreator)(configuration);
    return {
        /**
         * Endpoint that will set collar data collection mode
         * @param {string} serialNumber Serial Number
         * @param {IDeviceDataCollectionRequest} [iDeviceDataCollectionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestDeviceDataCollection: function (serialNumber, iDeviceDataCollectionRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.requestDeviceDataCollection(serialNumber, iDeviceDataCollectionRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Endpoint that will request the collar enter power off mode
         * @param {string} serialNumber Serial Number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestDeviceEnterPowerOffMode: function (serialNumber, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.requestDeviceEnterPowerOffMode(serialNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Endpoint that will request the collar perform a reset
         * @param {string} serialNumber Serial Number
         * @param {IDeviceResetRequest} [iDeviceResetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestDeviceReset: function (serialNumber, iDeviceResetRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.requestDeviceReset(serialNumber, iDeviceResetRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Endpoint that will request the collar perform a settings clear/resynch
         * @param {string} serialNumber Serial Number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestDeviceSettingsClear: function (serialNumber, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.requestDeviceSettingsClear(serialNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Endpoint that will request the collar perform an Wifi check in
         * @param {string} serialNumber Serial Number
         * @param {IDeviceWifiCheckInRequest} [iDeviceWifiCheckInRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestDeviceWifiCheckIn: function (serialNumber, iDeviceWifiCheckInRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.requestDeviceWifiCheckIn(serialNumber, iDeviceWifiCheckInRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DeviceControlApiFp = DeviceControlApiFp;
/**
 * DeviceControlApi - factory interface
 * @export
 */
var DeviceControlApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DeviceControlApiFp)(configuration);
    return {
        /**
         * Endpoint that will set collar data collection mode
         * @param {string} serialNumber Serial Number
         * @param {IDeviceDataCollectionRequest} [iDeviceDataCollectionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestDeviceDataCollection: function (serialNumber, iDeviceDataCollectionRequest, options) {
            return localVarFp.requestDeviceDataCollection(serialNumber, iDeviceDataCollectionRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Endpoint that will request the collar enter power off mode
         * @param {string} serialNumber Serial Number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestDeviceEnterPowerOffMode: function (serialNumber, options) {
            return localVarFp.requestDeviceEnterPowerOffMode(serialNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Endpoint that will request the collar perform a reset
         * @param {string} serialNumber Serial Number
         * @param {IDeviceResetRequest} [iDeviceResetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestDeviceReset: function (serialNumber, iDeviceResetRequest, options) {
            return localVarFp.requestDeviceReset(serialNumber, iDeviceResetRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Endpoint that will request the collar perform a settings clear/resynch
         * @param {string} serialNumber Serial Number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestDeviceSettingsClear: function (serialNumber, options) {
            return localVarFp.requestDeviceSettingsClear(serialNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Endpoint that will request the collar perform an Wifi check in
         * @param {string} serialNumber Serial Number
         * @param {IDeviceWifiCheckInRequest} [iDeviceWifiCheckInRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestDeviceWifiCheckIn: function (serialNumber, iDeviceWifiCheckInRequest, options) {
            return localVarFp.requestDeviceWifiCheckIn(serialNumber, iDeviceWifiCheckInRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DeviceControlApiFactory = DeviceControlApiFactory;
/**
 * DeviceControlApi - object-oriented interface
 * @export
 * @class DeviceControlApi
 * @extends {BaseAPI}
 */
var DeviceControlApi = /** @class */ (function (_super) {
    __extends(DeviceControlApi, _super);
    function DeviceControlApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Endpoint that will set collar data collection mode
     * @param {string} serialNumber Serial Number
     * @param {IDeviceDataCollectionRequest} [iDeviceDataCollectionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceControlApi
     */
    DeviceControlApi.prototype.requestDeviceDataCollection = function (serialNumber, iDeviceDataCollectionRequest, options) {
        var _this = this;
        return (0, exports.DeviceControlApiFp)(this.configuration).requestDeviceDataCollection(serialNumber, iDeviceDataCollectionRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Endpoint that will request the collar enter power off mode
     * @param {string} serialNumber Serial Number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceControlApi
     */
    DeviceControlApi.prototype.requestDeviceEnterPowerOffMode = function (serialNumber, options) {
        var _this = this;
        return (0, exports.DeviceControlApiFp)(this.configuration).requestDeviceEnterPowerOffMode(serialNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Endpoint that will request the collar perform a reset
     * @param {string} serialNumber Serial Number
     * @param {IDeviceResetRequest} [iDeviceResetRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceControlApi
     */
    DeviceControlApi.prototype.requestDeviceReset = function (serialNumber, iDeviceResetRequest, options) {
        var _this = this;
        return (0, exports.DeviceControlApiFp)(this.configuration).requestDeviceReset(serialNumber, iDeviceResetRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Endpoint that will request the collar perform a settings clear/resynch
     * @param {string} serialNumber Serial Number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceControlApi
     */
    DeviceControlApi.prototype.requestDeviceSettingsClear = function (serialNumber, options) {
        var _this = this;
        return (0, exports.DeviceControlApiFp)(this.configuration).requestDeviceSettingsClear(serialNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Endpoint that will request the collar perform an Wifi check in
     * @param {string} serialNumber Serial Number
     * @param {IDeviceWifiCheckInRequest} [iDeviceWifiCheckInRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceControlApi
     */
    DeviceControlApi.prototype.requestDeviceWifiCheckIn = function (serialNumber, iDeviceWifiCheckInRequest, options) {
        var _this = this;
        return (0, exports.DeviceControlApiFp)(this.configuration).requestDeviceWifiCheckIn(serialNumber, iDeviceWifiCheckInRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DeviceControlApi;
}(base_1.BaseAPI));
exports.DeviceControlApi = DeviceControlApi;
/**
 * DeviceHeartbeatApi - axios parameter creator
 * @export
 */
var DeviceHeartbeatApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Endpoint that will trigger heartbeat check over multicast.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleHeartbeatCheck: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/devices/heartbeat/check";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.DeviceHeartbeatApiAxiosParamCreator = DeviceHeartbeatApiAxiosParamCreator;
/**
 * DeviceHeartbeatApi - functional programming interface
 * @export
 */
var DeviceHeartbeatApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DeviceHeartbeatApiAxiosParamCreator)(configuration);
    return {
        /**
         * Endpoint that will trigger heartbeat check over multicast.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleHeartbeatCheck: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.scheduleHeartbeatCheck(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DeviceHeartbeatApiFp = DeviceHeartbeatApiFp;
/**
 * DeviceHeartbeatApi - factory interface
 * @export
 */
var DeviceHeartbeatApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DeviceHeartbeatApiFp)(configuration);
    return {
        /**
         * Endpoint that will trigger heartbeat check over multicast.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleHeartbeatCheck: function (options) {
            return localVarFp.scheduleHeartbeatCheck(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DeviceHeartbeatApiFactory = DeviceHeartbeatApiFactory;
/**
 * DeviceHeartbeatApi - object-oriented interface
 * @export
 * @class DeviceHeartbeatApi
 * @extends {BaseAPI}
 */
var DeviceHeartbeatApi = /** @class */ (function (_super) {
    __extends(DeviceHeartbeatApi, _super);
    function DeviceHeartbeatApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Endpoint that will trigger heartbeat check over multicast.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceHeartbeatApi
     */
    DeviceHeartbeatApi.prototype.scheduleHeartbeatCheck = function (options) {
        var _this = this;
        return (0, exports.DeviceHeartbeatApiFp)(this.configuration).scheduleHeartbeatCheck(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DeviceHeartbeatApi;
}(base_1.BaseAPI));
exports.DeviceHeartbeatApi = DeviceHeartbeatApi;
/**
 * DeviceMonitoringApi - axios parameter creator
 * @export
 */
var DeviceMonitoringApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Endpoint that will update the wifi check-in table with current timestamp
         * @param {string} serialNumber Serial Number
         * @param {IWifiCheckinStatusMessageDTO} [iWifiCheckinStatusMessageDTO] DTO object containing the wifi message data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wifiCheckIn: function (serialNumber, iWifiCheckinStatusMessageDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    (0, common_1.assertParamExists)('wifiCheckIn', 'serialNumber', serialNumber);
                    localVarPath = "/devices/{serialNumber}/monitoring/check-in/wifi"
                        .replace("{".concat("serialNumber", "}"), encodeURIComponent(String(serialNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iWifiCheckinStatusMessageDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.DeviceMonitoringApiAxiosParamCreator = DeviceMonitoringApiAxiosParamCreator;
/**
 * DeviceMonitoringApi - functional programming interface
 * @export
 */
var DeviceMonitoringApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DeviceMonitoringApiAxiosParamCreator)(configuration);
    return {
        /**
         * Endpoint that will update the wifi check-in table with current timestamp
         * @param {string} serialNumber Serial Number
         * @param {IWifiCheckinStatusMessageDTO} [iWifiCheckinStatusMessageDTO] DTO object containing the wifi message data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wifiCheckIn: function (serialNumber, iWifiCheckinStatusMessageDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.wifiCheckIn(serialNumber, iWifiCheckinStatusMessageDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DeviceMonitoringApiFp = DeviceMonitoringApiFp;
/**
 * DeviceMonitoringApi - factory interface
 * @export
 */
var DeviceMonitoringApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DeviceMonitoringApiFp)(configuration);
    return {
        /**
         * Endpoint that will update the wifi check-in table with current timestamp
         * @param {string} serialNumber Serial Number
         * @param {IWifiCheckinStatusMessageDTO} [iWifiCheckinStatusMessageDTO] DTO object containing the wifi message data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wifiCheckIn: function (serialNumber, iWifiCheckinStatusMessageDTO, options) {
            return localVarFp.wifiCheckIn(serialNumber, iWifiCheckinStatusMessageDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DeviceMonitoringApiFactory = DeviceMonitoringApiFactory;
/**
 * DeviceMonitoringApi - object-oriented interface
 * @export
 * @class DeviceMonitoringApi
 * @extends {BaseAPI}
 */
var DeviceMonitoringApi = /** @class */ (function (_super) {
    __extends(DeviceMonitoringApi, _super);
    function DeviceMonitoringApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Endpoint that will update the wifi check-in table with current timestamp
     * @param {string} serialNumber Serial Number
     * @param {IWifiCheckinStatusMessageDTO} [iWifiCheckinStatusMessageDTO] DTO object containing the wifi message data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceMonitoringApi
     */
    DeviceMonitoringApi.prototype.wifiCheckIn = function (serialNumber, iWifiCheckinStatusMessageDTO, options) {
        var _this = this;
        return (0, exports.DeviceMonitoringApiFp)(this.configuration).wifiCheckIn(serialNumber, iWifiCheckinStatusMessageDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DeviceMonitoringApi;
}(base_1.BaseAPI));
exports.DeviceMonitoringApi = DeviceMonitoringApi;
/**
 * DeviceRegistryApi - axios parameter creator
 * @export
 */
var DeviceRegistryApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Deletes device and device info from all tables, AWS IoT and TTN.
         * @param {string} serialNumber Serial Number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDevice: function (serialNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    (0, common_1.assertParamExists)('deleteDevice', 'serialNumber', serialNumber);
                    localVarPath = "/devices/{serialNumber}"
                        .replace("{".concat("serialNumber", "}"), encodeURIComponent(String(serialNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Retrieve all devices for the context farm
         * @param {Array<string>} [serialNumbers] Filter device states to devices in list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllDevices: function (serialNumbers, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/devices";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (serialNumbers) {
                        localVarQueryParameter['serialNumbers'] = serialNumbers;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Retrieve device registration information
         * @param {string} serialNumber Serial Number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findBySerialNumber: function (serialNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    (0, common_1.assertParamExists)('findBySerialNumber', 'serialNumber', serialNumber);
                    localVarPath = "/devices/{serialNumber}"
                        .replace("{".concat("serialNumber", "}"), encodeURIComponent(String(serialNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get device power off mode
         * @param {string} serialNumber Serial Number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findDevicePowerOffMode: function (serialNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    (0, common_1.assertParamExists)('findDevicePowerOffMode', 'serialNumber', serialNumber);
                    localVarPath = "/devices/{serialNumber}/power-off-mode"
                        .replace("{".concat("serialNumber", "}"), encodeURIComponent(String(serialNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Pre-provision a device to a farm
         * @param {string} serialNumber Serial Number
         * @param {IPreProvisionToFarmRequestDTO} iPreProvisionToFarmRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preProvisionToFarm: function (serialNumber, iPreProvisionToFarmRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    (0, common_1.assertParamExists)('preProvisionToFarm', 'serialNumber', serialNumber);
                    // verify required parameter 'iPreProvisionToFarmRequestDTO' is not null or undefined
                    (0, common_1.assertParamExists)('preProvisionToFarm', 'iPreProvisionToFarmRequestDTO', iPreProvisionToFarmRequestDTO);
                    localVarPath = "/devices/{serialNumber}/farm"
                        .replace("{".concat("serialNumber", "}"), encodeURIComponent(String(serialNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iPreProvisionToFarmRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {IRegisterDeviceRequestDTO} iRegisterDeviceRequestDTO DTO object containing the message data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerDevice: function (iRegisterDeviceRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'iRegisterDeviceRequestDTO' is not null or undefined
                    (0, common_1.assertParamExists)('registerDevice', 'iRegisterDeviceRequestDTO', iRegisterDeviceRequestDTO);
                    localVarPath = "/devices/registry";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iRegisterDeviceRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Remove pre-provisioned farm from the device
         * @param {string} serialNumber Serial Number
         * @param {IDeleteFarmPreProvisioningRequestDTO} iDeleteFarmPreProvisioningRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFarmPreProvisioning: function (serialNumber, iDeleteFarmPreProvisioningRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    (0, common_1.assertParamExists)('removeFarmPreProvisioning', 'serialNumber', serialNumber);
                    // verify required parameter 'iDeleteFarmPreProvisioningRequestDTO' is not null or undefined
                    (0, common_1.assertParamExists)('removeFarmPreProvisioning', 'iDeleteFarmPreProvisioningRequestDTO', iDeleteFarmPreProvisioningRequestDTO);
                    localVarPath = "/devices/{serialNumber}/farm"
                        .replace("{".concat("serialNumber", "}"), encodeURIComponent(String(serialNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iDeleteFarmPreProvisioningRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.DeviceRegistryApiAxiosParamCreator = DeviceRegistryApiAxiosParamCreator;
/**
 * DeviceRegistryApi - functional programming interface
 * @export
 */
var DeviceRegistryApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DeviceRegistryApiAxiosParamCreator)(configuration);
    return {
        /**
         * Deletes device and device info from all tables, AWS IoT and TTN.
         * @param {string} serialNumber Serial Number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDevice: function (serialNumber, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteDevice(serialNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Retrieve all devices for the context farm
         * @param {Array<string>} [serialNumbers] Filter device states to devices in list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllDevices: function (serialNumbers, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findAllDevices(serialNumbers, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Retrieve device registration information
         * @param {string} serialNumber Serial Number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findBySerialNumber: function (serialNumber, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findBySerialNumber(serialNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get device power off mode
         * @param {string} serialNumber Serial Number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findDevicePowerOffMode: function (serialNumber, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findDevicePowerOffMode(serialNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Pre-provision a device to a farm
         * @param {string} serialNumber Serial Number
         * @param {IPreProvisionToFarmRequestDTO} iPreProvisionToFarmRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preProvisionToFarm: function (serialNumber, iPreProvisionToFarmRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.preProvisionToFarm(serialNumber, iPreProvisionToFarmRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {IRegisterDeviceRequestDTO} iRegisterDeviceRequestDTO DTO object containing the message data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerDevice: function (iRegisterDeviceRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.registerDevice(iRegisterDeviceRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Remove pre-provisioned farm from the device
         * @param {string} serialNumber Serial Number
         * @param {IDeleteFarmPreProvisioningRequestDTO} iDeleteFarmPreProvisioningRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFarmPreProvisioning: function (serialNumber, iDeleteFarmPreProvisioningRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.removeFarmPreProvisioning(serialNumber, iDeleteFarmPreProvisioningRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DeviceRegistryApiFp = DeviceRegistryApiFp;
/**
 * DeviceRegistryApi - factory interface
 * @export
 */
var DeviceRegistryApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DeviceRegistryApiFp)(configuration);
    return {
        /**
         * Deletes device and device info from all tables, AWS IoT and TTN.
         * @param {string} serialNumber Serial Number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDevice: function (serialNumber, options) {
            return localVarFp.deleteDevice(serialNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieve all devices for the context farm
         * @param {Array<string>} [serialNumbers] Filter device states to devices in list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllDevices: function (serialNumbers, options) {
            return localVarFp.findAllDevices(serialNumbers, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieve device registration information
         * @param {string} serialNumber Serial Number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findBySerialNumber: function (serialNumber, options) {
            return localVarFp.findBySerialNumber(serialNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get device power off mode
         * @param {string} serialNumber Serial Number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findDevicePowerOffMode: function (serialNumber, options) {
            return localVarFp.findDevicePowerOffMode(serialNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Pre-provision a device to a farm
         * @param {string} serialNumber Serial Number
         * @param {IPreProvisionToFarmRequestDTO} iPreProvisionToFarmRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preProvisionToFarm: function (serialNumber, iPreProvisionToFarmRequestDTO, options) {
            return localVarFp.preProvisionToFarm(serialNumber, iPreProvisionToFarmRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {IRegisterDeviceRequestDTO} iRegisterDeviceRequestDTO DTO object containing the message data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerDevice: function (iRegisterDeviceRequestDTO, options) {
            return localVarFp.registerDevice(iRegisterDeviceRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Remove pre-provisioned farm from the device
         * @param {string} serialNumber Serial Number
         * @param {IDeleteFarmPreProvisioningRequestDTO} iDeleteFarmPreProvisioningRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFarmPreProvisioning: function (serialNumber, iDeleteFarmPreProvisioningRequestDTO, options) {
            return localVarFp.removeFarmPreProvisioning(serialNumber, iDeleteFarmPreProvisioningRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DeviceRegistryApiFactory = DeviceRegistryApiFactory;
/**
 * DeviceRegistryApi - object-oriented interface
 * @export
 * @class DeviceRegistryApi
 * @extends {BaseAPI}
 */
var DeviceRegistryApi = /** @class */ (function (_super) {
    __extends(DeviceRegistryApi, _super);
    function DeviceRegistryApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Deletes device and device info from all tables, AWS IoT and TTN.
     * @param {string} serialNumber Serial Number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceRegistryApi
     */
    DeviceRegistryApi.prototype.deleteDevice = function (serialNumber, options) {
        var _this = this;
        return (0, exports.DeviceRegistryApiFp)(this.configuration).deleteDevice(serialNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieve all devices for the context farm
     * @param {Array<string>} [serialNumbers] Filter device states to devices in list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceRegistryApi
     */
    DeviceRegistryApi.prototype.findAllDevices = function (serialNumbers, options) {
        var _this = this;
        return (0, exports.DeviceRegistryApiFp)(this.configuration).findAllDevices(serialNumbers, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieve device registration information
     * @param {string} serialNumber Serial Number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceRegistryApi
     */
    DeviceRegistryApi.prototype.findBySerialNumber = function (serialNumber, options) {
        var _this = this;
        return (0, exports.DeviceRegistryApiFp)(this.configuration).findBySerialNumber(serialNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get device power off mode
     * @param {string} serialNumber Serial Number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceRegistryApi
     */
    DeviceRegistryApi.prototype.findDevicePowerOffMode = function (serialNumber, options) {
        var _this = this;
        return (0, exports.DeviceRegistryApiFp)(this.configuration).findDevicePowerOffMode(serialNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Pre-provision a device to a farm
     * @param {string} serialNumber Serial Number
     * @param {IPreProvisionToFarmRequestDTO} iPreProvisionToFarmRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceRegistryApi
     */
    DeviceRegistryApi.prototype.preProvisionToFarm = function (serialNumber, iPreProvisionToFarmRequestDTO, options) {
        var _this = this;
        return (0, exports.DeviceRegistryApiFp)(this.configuration).preProvisionToFarm(serialNumber, iPreProvisionToFarmRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {IRegisterDeviceRequestDTO} iRegisterDeviceRequestDTO DTO object containing the message data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceRegistryApi
     */
    DeviceRegistryApi.prototype.registerDevice = function (iRegisterDeviceRequestDTO, options) {
        var _this = this;
        return (0, exports.DeviceRegistryApiFp)(this.configuration).registerDevice(iRegisterDeviceRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Remove pre-provisioned farm from the device
     * @param {string} serialNumber Serial Number
     * @param {IDeleteFarmPreProvisioningRequestDTO} iDeleteFarmPreProvisioningRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceRegistryApi
     */
    DeviceRegistryApi.prototype.removeFarmPreProvisioning = function (serialNumber, iDeleteFarmPreProvisioningRequestDTO, options) {
        var _this = this;
        return (0, exports.DeviceRegistryApiFp)(this.configuration).removeFarmPreProvisioning(serialNumber, iDeleteFarmPreProvisioningRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DeviceRegistryApi;
}(base_1.BaseAPI));
exports.DeviceRegistryApi = DeviceRegistryApi;
/**
 * DeviceStatsApi - axios parameter creator
 * @export
 */
var DeviceStatsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Retrieve device current stats from the backend
         * @param {string} serialNumber Serial Number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findStats: function (serialNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    (0, common_1.assertParamExists)('findStats', 'serialNumber', serialNumber);
                    localVarPath = "/devices/{serialNumber}/stats"
                        .replace("{".concat("serialNumber", "}"), encodeURIComponent(String(serialNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findStatsBySerialNumbers: function (requestBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'requestBody' is not null or undefined
                    (0, common_1.assertParamExists)('findStatsBySerialNumbers', 'requestBody', requestBody);
                    localVarPath = "/devices/stats/search";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.DeviceStatsApiAxiosParamCreator = DeviceStatsApiAxiosParamCreator;
/**
 * DeviceStatsApi - functional programming interface
 * @export
 */
var DeviceStatsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DeviceStatsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Retrieve device current stats from the backend
         * @param {string} serialNumber Serial Number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findStats: function (serialNumber, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findStats(serialNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findStatsBySerialNumbers: function (requestBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.findStatsBySerialNumbers(requestBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DeviceStatsApiFp = DeviceStatsApiFp;
/**
 * DeviceStatsApi - factory interface
 * @export
 */
var DeviceStatsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DeviceStatsApiFp)(configuration);
    return {
        /**
         * Retrieve device current stats from the backend
         * @param {string} serialNumber Serial Number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findStats: function (serialNumber, options) {
            return localVarFp.findStats(serialNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findStatsBySerialNumbers: function (requestBody, options) {
            return localVarFp.findStatsBySerialNumbers(requestBody, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DeviceStatsApiFactory = DeviceStatsApiFactory;
/**
 * DeviceStatsApi - object-oriented interface
 * @export
 * @class DeviceStatsApi
 * @extends {BaseAPI}
 */
var DeviceStatsApi = /** @class */ (function (_super) {
    __extends(DeviceStatsApi, _super);
    function DeviceStatsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Retrieve device current stats from the backend
     * @param {string} serialNumber Serial Number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceStatsApi
     */
    DeviceStatsApi.prototype.findStats = function (serialNumber, options) {
        var _this = this;
        return (0, exports.DeviceStatsApiFp)(this.configuration).findStats(serialNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {Array<string>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceStatsApi
     */
    DeviceStatsApi.prototype.findStatsBySerialNumbers = function (requestBody, options) {
        var _this = this;
        return (0, exports.DeviceStatsApiFp)(this.configuration).findStatsBySerialNumbers(requestBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DeviceStatsApi;
}(base_1.BaseAPI));
exports.DeviceStatsApi = DeviceStatsApi;
/**
 * DeviceStatusApi - axios parameter creator
 * @export
 */
var DeviceStatusApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Update device status
         * @param {string} serialNumber Device serial number
         * @param {IDeviceStatusDTO} iDeviceStatusDTO DTO object containing the device status update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStatus: function (serialNumber, iDeviceStatusDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    (0, common_1.assertParamExists)('updateStatus', 'serialNumber', serialNumber);
                    // verify required parameter 'iDeviceStatusDTO' is not null or undefined
                    (0, common_1.assertParamExists)('updateStatus', 'iDeviceStatusDTO', iDeviceStatusDTO);
                    localVarPath = "/devices/{serialNumber}/status"
                        .replace("{".concat("serialNumber", "}"), encodeURIComponent(String(serialNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iDeviceStatusDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.DeviceStatusApiAxiosParamCreator = DeviceStatusApiAxiosParamCreator;
/**
 * DeviceStatusApi - functional programming interface
 * @export
 */
var DeviceStatusApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DeviceStatusApiAxiosParamCreator)(configuration);
    return {
        /**
         * Update device status
         * @param {string} serialNumber Device serial number
         * @param {IDeviceStatusDTO} iDeviceStatusDTO DTO object containing the device status update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStatus: function (serialNumber, iDeviceStatusDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateStatus(serialNumber, iDeviceStatusDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DeviceStatusApiFp = DeviceStatusApiFp;
/**
 * DeviceStatusApi - factory interface
 * @export
 */
var DeviceStatusApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DeviceStatusApiFp)(configuration);
    return {
        /**
         * Update device status
         * @param {string} serialNumber Device serial number
         * @param {IDeviceStatusDTO} iDeviceStatusDTO DTO object containing the device status update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStatus: function (serialNumber, iDeviceStatusDTO, options) {
            return localVarFp.updateStatus(serialNumber, iDeviceStatusDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DeviceStatusApiFactory = DeviceStatusApiFactory;
/**
 * DeviceStatusApi - object-oriented interface
 * @export
 * @class DeviceStatusApi
 * @extends {BaseAPI}
 */
var DeviceStatusApi = /** @class */ (function (_super) {
    __extends(DeviceStatusApi, _super);
    function DeviceStatusApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Update device status
     * @param {string} serialNumber Device serial number
     * @param {IDeviceStatusDTO} iDeviceStatusDTO DTO object containing the device status update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceStatusApi
     */
    DeviceStatusApi.prototype.updateStatus = function (serialNumber, iDeviceStatusDTO, options) {
        var _this = this;
        return (0, exports.DeviceStatusApiFp)(this.configuration).updateStatus(serialNumber, iDeviceStatusDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DeviceStatusApi;
}(base_1.BaseAPI));
exports.DeviceStatusApi = DeviceStatusApi;
/**
 * MessagingApi - axios parameter creator
 * @export
 */
var MessagingApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} multicastGroupId Identifies a group to which messages will be multicasted to. At the moment this translates to \&quot;farmId\&quot;.
         * @param {IScheduleRequestMessageDTO} iScheduleRequestMessageDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleMulticastRequestMessage: function (multicastGroupId, iScheduleRequestMessageDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'multicastGroupId' is not null or undefined
                    (0, common_1.assertParamExists)('scheduleMulticastRequestMessage', 'multicastGroupId', multicastGroupId);
                    // verify required parameter 'iScheduleRequestMessageDTO' is not null or undefined
                    (0, common_1.assertParamExists)('scheduleMulticastRequestMessage', 'iScheduleRequestMessageDTO', iScheduleRequestMessageDTO);
                    localVarPath = "/devices/messages/multicast/{multicastGroupId}/request"
                        .replace("{".concat("multicastGroupId", "}"), encodeURIComponent(String(multicastGroupId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iScheduleRequestMessageDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {string} serialNumber Serial Number
         * @param {IScheduleRequestMessageDTO} iScheduleRequestMessageDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleRequestMessage: function (serialNumber, iScheduleRequestMessageDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    (0, common_1.assertParamExists)('scheduleRequestMessage', 'serialNumber', serialNumber);
                    // verify required parameter 'iScheduleRequestMessageDTO' is not null or undefined
                    (0, common_1.assertParamExists)('scheduleRequestMessage', 'iScheduleRequestMessageDTO', iScheduleRequestMessageDTO);
                    localVarPath = "/devices/{serialNumber}/messages/requests/"
                        .replace("{".concat("serialNumber", "}"), encodeURIComponent(String(serialNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iScheduleRequestMessageDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Endpoint that will cause the LED on a collar to turn on for a limited amount of time
         * @param {string} serialNumber Serial Number
         * @param {IDeviceLedIndicatorRequestDTO} [iDeviceLedIndicatorRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerLed: function (serialNumber, iDeviceLedIndicatorRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    (0, common_1.assertParamExists)('triggerLed', 'serialNumber', serialNumber);
                    localVarPath = "/devices/{serialNumber}/led-indicator"
                        .replace("{".concat("serialNumber", "}"), encodeURIComponent(String(serialNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iDeviceLedIndicatorRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Endpoint that will cause the LED on the list of supplied collars to turn on for a limited amount of time
         * @param {Array<IDeviceLedIndicatorBatchRequestDTO>} [iDeviceLedIndicatorBatchRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerLedBatch: function (iDeviceLedIndicatorBatchRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/devices/led-indicators";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iDeviceLedIndicatorBatchRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.MessagingApiAxiosParamCreator = MessagingApiAxiosParamCreator;
/**
 * MessagingApi - functional programming interface
 * @export
 */
var MessagingApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.MessagingApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} multicastGroupId Identifies a group to which messages will be multicasted to. At the moment this translates to \&quot;farmId\&quot;.
         * @param {IScheduleRequestMessageDTO} iScheduleRequestMessageDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleMulticastRequestMessage: function (multicastGroupId, iScheduleRequestMessageDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.scheduleMulticastRequestMessage(multicastGroupId, iScheduleRequestMessageDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} serialNumber Serial Number
         * @param {IScheduleRequestMessageDTO} iScheduleRequestMessageDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleRequestMessage: function (serialNumber, iScheduleRequestMessageDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.scheduleRequestMessage(serialNumber, iScheduleRequestMessageDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Endpoint that will cause the LED on a collar to turn on for a limited amount of time
         * @param {string} serialNumber Serial Number
         * @param {IDeviceLedIndicatorRequestDTO} [iDeviceLedIndicatorRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerLed: function (serialNumber, iDeviceLedIndicatorRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.triggerLed(serialNumber, iDeviceLedIndicatorRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Endpoint that will cause the LED on the list of supplied collars to turn on for a limited amount of time
         * @param {Array<IDeviceLedIndicatorBatchRequestDTO>} [iDeviceLedIndicatorBatchRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerLedBatch: function (iDeviceLedIndicatorBatchRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.triggerLedBatch(iDeviceLedIndicatorBatchRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.MessagingApiFp = MessagingApiFp;
/**
 * MessagingApi - factory interface
 * @export
 */
var MessagingApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.MessagingApiFp)(configuration);
    return {
        /**
         *
         * @param {string} multicastGroupId Identifies a group to which messages will be multicasted to. At the moment this translates to \&quot;farmId\&quot;.
         * @param {IScheduleRequestMessageDTO} iScheduleRequestMessageDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleMulticastRequestMessage: function (multicastGroupId, iScheduleRequestMessageDTO, options) {
            return localVarFp.scheduleMulticastRequestMessage(multicastGroupId, iScheduleRequestMessageDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} serialNumber Serial Number
         * @param {IScheduleRequestMessageDTO} iScheduleRequestMessageDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleRequestMessage: function (serialNumber, iScheduleRequestMessageDTO, options) {
            return localVarFp.scheduleRequestMessage(serialNumber, iScheduleRequestMessageDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Endpoint that will cause the LED on a collar to turn on for a limited amount of time
         * @param {string} serialNumber Serial Number
         * @param {IDeviceLedIndicatorRequestDTO} [iDeviceLedIndicatorRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerLed: function (serialNumber, iDeviceLedIndicatorRequestDTO, options) {
            return localVarFp.triggerLed(serialNumber, iDeviceLedIndicatorRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Endpoint that will cause the LED on the list of supplied collars to turn on for a limited amount of time
         * @param {Array<IDeviceLedIndicatorBatchRequestDTO>} [iDeviceLedIndicatorBatchRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerLedBatch: function (iDeviceLedIndicatorBatchRequestDTO, options) {
            return localVarFp.triggerLedBatch(iDeviceLedIndicatorBatchRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.MessagingApiFactory = MessagingApiFactory;
/**
 * MessagingApi - object-oriented interface
 * @export
 * @class MessagingApi
 * @extends {BaseAPI}
 */
var MessagingApi = /** @class */ (function (_super) {
    __extends(MessagingApi, _super);
    function MessagingApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} multicastGroupId Identifies a group to which messages will be multicasted to. At the moment this translates to \&quot;farmId\&quot;.
     * @param {IScheduleRequestMessageDTO} iScheduleRequestMessageDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagingApi
     */
    MessagingApi.prototype.scheduleMulticastRequestMessage = function (multicastGroupId, iScheduleRequestMessageDTO, options) {
        var _this = this;
        return (0, exports.MessagingApiFp)(this.configuration).scheduleMulticastRequestMessage(multicastGroupId, iScheduleRequestMessageDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} serialNumber Serial Number
     * @param {IScheduleRequestMessageDTO} iScheduleRequestMessageDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagingApi
     */
    MessagingApi.prototype.scheduleRequestMessage = function (serialNumber, iScheduleRequestMessageDTO, options) {
        var _this = this;
        return (0, exports.MessagingApiFp)(this.configuration).scheduleRequestMessage(serialNumber, iScheduleRequestMessageDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Endpoint that will cause the LED on a collar to turn on for a limited amount of time
     * @param {string} serialNumber Serial Number
     * @param {IDeviceLedIndicatorRequestDTO} [iDeviceLedIndicatorRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagingApi
     */
    MessagingApi.prototype.triggerLed = function (serialNumber, iDeviceLedIndicatorRequestDTO, options) {
        var _this = this;
        return (0, exports.MessagingApiFp)(this.configuration).triggerLed(serialNumber, iDeviceLedIndicatorRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Endpoint that will cause the LED on the list of supplied collars to turn on for a limited amount of time
     * @param {Array<IDeviceLedIndicatorBatchRequestDTO>} [iDeviceLedIndicatorBatchRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagingApi
     */
    MessagingApi.prototype.triggerLedBatch = function (iDeviceLedIndicatorBatchRequestDTO, options) {
        var _this = this;
        return (0, exports.MessagingApiFp)(this.configuration).triggerLedBatch(iDeviceLedIndicatorBatchRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return MessagingApi;
}(base_1.BaseAPI));
exports.MessagingApi = MessagingApi;
/**
 * ShadowApi - axios parameter creator
 * @export
 */
var ShadowApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Sets device shadow to it\'s initial state.
         * @param {string} serialNumber Serial Number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetDeviceShadow: function (serialNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    (0, common_1.assertParamExists)('resetDeviceShadow', 'serialNumber', serialNumber);
                    localVarPath = "/devices/{serialNumber}/shadow"
                        .replace("{".concat("serialNumber", "}"), encodeURIComponent(String(serialNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.ShadowApiAxiosParamCreator = ShadowApiAxiosParamCreator;
/**
 * ShadowApi - functional programming interface
 * @export
 */
var ShadowApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ShadowApiAxiosParamCreator)(configuration);
    return {
        /**
         * Sets device shadow to it\'s initial state.
         * @param {string} serialNumber Serial Number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetDeviceShadow: function (serialNumber, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.resetDeviceShadow(serialNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ShadowApiFp = ShadowApiFp;
/**
 * ShadowApi - factory interface
 * @export
 */
var ShadowApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ShadowApiFp)(configuration);
    return {
        /**
         * Sets device shadow to it\'s initial state.
         * @param {string} serialNumber Serial Number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetDeviceShadow: function (serialNumber, options) {
            return localVarFp.resetDeviceShadow(serialNumber, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ShadowApiFactory = ShadowApiFactory;
/**
 * ShadowApi - object-oriented interface
 * @export
 * @class ShadowApi
 * @extends {BaseAPI}
 */
var ShadowApi = /** @class */ (function (_super) {
    __extends(ShadowApi, _super);
    function ShadowApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Sets device shadow to it\'s initial state.
     * @param {string} serialNumber Serial Number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShadowApi
     */
    ShadowApi.prototype.resetDeviceShadow = function (serialNumber, options) {
        var _this = this;
        return (0, exports.ShadowApiFp)(this.configuration).resetDeviceShadow(serialNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ShadowApi;
}(base_1.BaseAPI));
exports.ShadowApi = ShadowApi;
